module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Accessories-1.044c1fe4.jpg";